import React from "react";

export default function PngIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21 6.832v14.25a3 3 0 0 1-3 3v-1.5a1.5 1.5 0 0 0 1.5-1.5V6.832h-3a2.25 2.25 0 0 1-2.25-2.25v-3H6a1.5 1.5 0 0 0-1.5 1.5v13.5H3v-13.5a3 3 0 0 1 3-3h8.25L21 6.832ZM15.36 19.03c.114.229.184.475.21.739h-1.164a1.197 1.197 0 0 0-.145-.374 1.033 1.033 0 0 0-.255-.285 1.061 1.061 0 0 0-.356-.19 1.442 1.442 0 0 0-.448-.065c-.428 0-.76.15-.998.452-.234.302-.351.727-.351 1.275v.747c0 .351.048.659.145.923.1.263.252.47.457.62.205.146.464.219.778.219.275 0 .504-.048.685-.145.182-.1.318-.232.41-.396.09-.164.135-.345.135-.544v-.383h-1.235v-.883h2.365v1.195c0 .29-.049.566-.145.826a1.936 1.936 0 0 1-.44.686c-.196.2-.444.356-.742.47a2.968 2.968 0 0 1-1.046.167c-.431 0-.808-.066-1.13-.198a2.17 2.17 0 0 1-.8-.567 2.372 2.372 0 0 1-.479-.87 3.725 3.725 0 0 1-.158-1.116v-.76c0-.542.1-1.017.3-1.424.201-.407.493-.724.874-.95.383-.228.846-.342 1.388-.342.358 0 .675.05.954.15.281.1.521.237.72.412.2.176.357.38.47.611ZM2.4 17.971H0v5.999h1.187v-2.013H2.39c.43 0 .796-.086 1.098-.26.305-.175.536-.412.695-.711a2.12 2.12 0 0 0 .241-1.015c0-.375-.079-.714-.237-1.015a1.763 1.763 0 0 0-.69-.717c-.299-.178-.665-.268-1.099-.268Zm.817 2c0 .223-.043.413-.128.571a.862.862 0 0 1-.356.36 1.19 1.19 0 0 1-.562.123h-.989v-2.109h.989c.328 0 .584.09.769.273.185.181.277.442.277.782Zm2.947 3.999v-4.012h.048l2.641 4.012h.985V17.97H8.713v3.99h-.049l-2.628-3.99h-.993v5.999h1.12Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
